(function () {
    "use strict";

    // @ngInject
    function NativeControllerCtor($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NativeController';
    }


    Controllers.NativeController = Class(Controllers.BaseController, {
        constructor: NativeControllerCtor
    });
}());
